import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const Alerts = ({ snackbar, handleClose, darkMode }) => {
  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ minWidth: 400 }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        sx={{
          width: '100%',
          fontSize: '1.1rem',
          padding: '12px 24px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          backgroundColor: 'background.default',
          color: 'text.primary' ,
          '& .MuiAlert-icon': {
            fontSize: '1.5rem',
          },
          '& .MuiAlert-message': {
            fontWeight: 500,
          },
        }}
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default Alerts;
